'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderOffsetSelector = exports.deliveryOffsetSelector = exports.creditCardPaymentSuspended = exports.unhandledSelectedSelector = exports.unhandledDataSelector = exports.orderObjectSelector = exports.availablePaymentsForOrder = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _cart = require('@arreeba/ristoranti-lib/lib/cart');

var _cart2 = _interopRequireDefault(_cart);

var _common = require('./common');

var _constants = require('../constants');

var _cart3 = require('./cart');

var _voucher = require('./voucher');

var _voucher2 = require('../helpers/voucher');

var _voucher3 = _interopRequireDefault(_voucher2);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var availablePaymentsForOrder = exports.availablePaymentsForOrder = (0, _reselect.createSelector)(function (state) {
  return state.app.config.order.paymentType;
}, _common.orderTypeSelector, function (available, orderType) {
  var _result, _result2;

  var result = (_result = {}, _defineProperty(_result, _constants.PAYMENT_UNHANDLED, true), _defineProperty(_result, _constants.PAYMENT_METHOD_CC, true), _result);

  if (!available) {
    // assume they're all available if config is missing
    return result;
  }

  var object = _lodash2.default.find(available, { type: orderType });
  if (!object || !object.payments) {
    return result;
  }

  result = (_result2 = {}, _defineProperty(_result2, _constants.PAYMENT_UNHANDLED, false), _defineProperty(_result2, _constants.PAYMENT_METHOD_CC, false), _result2);

  object.payments.forEach(function (paymentType) {
    result[paymentType] = true;
  });

  return result;
});

var orderObjectSelector = exports.orderObjectSelector = function orderObjectSelector(localizedLabels) {
  return (0, _reselect.createSelector)((0, _cart3.cartSelector)(localizedLabels), _cart3.cartGroupedSelector, _common.currentOrderSelector, function (cartData, cartGrouped, _ref) {
    var orderType = _ref.orderType,
        deliveryTime = _ref.deliveryTime,
        deliveryDate = _ref.deliveryDate,
        paymentType = _ref.paymentType;

    return {
      cart: cartGrouped,
      orderType: orderType,
      orderTime: deliveryTime,
      orderDate: deliveryDate,
      paymentType: paymentType,
      subtotal: cartData.subtotal,
      total: cartData.total,
      extraCosts: cartData.extraCosts
    };
  });
};

var unhandledDataSelector = exports.unhandledDataSelector = function unhandledDataSelector(_ref2) {
  var PAY_WITH = _ref2.PAY_WITH,
      PAY_EXACT_AMOUNT = _ref2.PAY_EXACT_AMOUNT,
      PAY_WITH_STAMPS = _ref2.PAY_WITH_STAMPS;
  return (0, _reselect.createSelector)(function (state) {
    return state.order.cart;
  }, function (state) {
    return state.order.extraCosts;
  }, _common.orderTypeSelector, _voucher.usableVouchersSelector, function (state) {
    return state.order.selectedVoucher;
  }, function (state) {
    return state.app.config.order;
  }, function (cart, extraCosts, orderType, userVouchers, selectedVoucher, orderConfig) {
    var availableCash = [1000, 2000, 3000, 5000, 10000];
    var total = selectedVoucher ? _voucher3.default.cartTotalWithVoucher(cart, extraCosts[orderType], selectedVoucher, userVouchers) : _cart2.default.total(cart, extraCosts[orderType]);
    var roundedTotal = Math.floor(total / 1000) * 1000;
    var nextRoundedTotal = total - roundedTotal < 500 ? roundedTotal + 500 : roundedTotal + 1000;
    var nextAvailableCash = _lodash2.default.map(_lodash2.default.filter(availableCash, function (c) {
      return c > nextRoundedTotal;
    }), function (x) {
      return {
        label: PAY_WITH + ' ' + _i18n2.default.formatPrice(x),
        value: x
      };
    });

    var data = [{ label: PAY_EXACT_AMOUNT, value: total },
    // TODO: da modificare (creare un flag apposito per il pagamento con i ticket)
    orderConfig.ticketRestaurantAccepted ? { label: PAY_WITH_STAMPS, value: 529 } : null, { label: PAY_WITH + ' ' + _i18n2.default.formatPrice(nextRoundedTotal), value: nextRoundedTotal }].concat(_toConsumableArray(nextAvailableCash)).filter(function (item) {
      return item;
    });

    return _lodash2.default.sortBy(data, 'value');
  });
};

var unhandledSelectedSelector = exports.unhandledSelectedSelector = function unhandledSelectedSelector(unhandledLabels) {
  return (0, _reselect.createSelector)([unhandledDataSelector(unhandledLabels), function (state) {
    return state.order.unhandledExpectedAmount;
  }], function (data, selected) {
    if (!selected) {
      return data[0].value;
    }
    return selected;
  });
};

var creditCardPaymentSuspended = exports.creditCardPaymentSuspended = (0, _reselect.createSelector)(function (state) {
  return state.app.config.order;
}, function (orderConfig) {
  if (orderConfig.creditCardPaymentSuspended) {
    return true;
  }
  return false;
});

var deliveryOffsetSelector = exports.deliveryOffsetSelector = (0, _reselect.createSelector)(function (state) {
  return state.order.deliveryAreaCustomOffset;
}, function (state) {
  return state.app.config.order.delivery.offset;
}, function (customOffset, configOffset) {
  if (!customOffset) return configOffset || 0;
  return configOffset;
});

var orderOffsetSelector = exports.orderOffsetSelector = (0, _reselect.createSelector)(function (state) {
  return state.order.targetRestaurant;
}, function (state) {
  return state.app.merchant.restaurants;
}, function (state) {
  return state.order.deliveryAreaCustomOffset;
}, function (state) {
  return state.order.orderType;
}, function (targetRestaurantId, restaurants, deliveryOffset, orderType) {
  if (!targetRestaurantId) return 0;

  if (orderType === _constants.ORDER_TYPE_DELIVERY) return deliveryOffset;

  var restaurant = _lodash2.default.find(restaurants, { id: targetRestaurantId }) || {};
  var takeAwayService = _lodash2.default.find(restaurant.services, { id: 'takeAway', active: true }) || {};

  return takeAwayService.offset || 0;
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/selectors/order.js
// module id = 198
// module chunks = 0